import React, { useState, useEffect, useRef } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

const frequencies = {
  1: { name: "Purificación", hz: "432 Hz", color: "#22c55e" },
  2: { name: "Conexión", hz: "528 Hz", color: "#3b82f6" },
  3: { name: "Abundancia", hz: "888 Hz", color: "#eab308" },
  4: { name: "Intuición", hz: "963 Hz", color: "#8b5cf6" },
  5: { name: "Sanación", hz: "639 Hz", color: "#ec4899" },
  6: { name: "Manifestación", hz: "777 Hz", color: "#f97316" },
  7: { name: "Integración", hz: "888 Hz + 528 Hz", color: "#eab308" },
  8: { name: "Abundancia", hz: "888 Hz", color: "#eab308" },
  9: { name: "Relaciones", hz: "639 Hz", color: "#ec4899" }
}

const AudioPlayer = ({ isPlaying, onTogglePlay, chapterId }) => {
  const [volume, setVolume] = useState(70)
  const [showInfo, setShowInfo] = useState(false)
  const freq = frequencies[chapterId] || frequencies[1]

  return (
    <motion.div 
      className="audio-player"
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
    >
      <div className="player-content">
        <div className="player-info">
          <div className="freq-indicator" style={{ backgroundColor: freq.color }}>
            <span className="freq-dot"></span>
          </div>
          <div className="player-text">
            <span className="player-freq">{freq.hz}</span>
            <span className="player-name">{freq.name}</span>
          </div>
        </div>

        <div className="player-controls">
          <button 
            className="play-btn"
            onClick={onTogglePlay}
            style={{ backgroundColor: freq.color }}
          >
            {isPlaying ? '⏸' : '▶'}
          </button>
        </div>

        <div className="player-extra">
          <button 
            className="info-btn"
            onClick={() => setShowInfo(!showInfo)}
          >
            ℹ️
          </button>
        </div>
      </div>

      <AnimatePresence>
        {showInfo && (
          <motion.div 
            className="player-info-panel"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
          >
            <p>
              <strong>Frecuencia recomendada:</strong> {freq.hz}<br/>
              <strong>Beneficio:</strong> {freq.name}<br/>
              <strong>Consejo:</strong> Escucha con auriculares para mayor efectividad.
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  )
}

export default AudioPlayer
